/**
 * TYT Platform API
 * This is the TYT Platform API. It is used by TYT's apps to interact 
 * with the underlying platform. 
 *
 * NOTE: This file is auto generated. 
 * Do not edit this file manually.
 */

import { BaseModel, Expand, Model, Type } from '../../common';

import { ApiTuneIn } from './TuneIn';
import { ApiBrandColor } from './BrandColor';

export interface AbbreviatedShowRequest {

    id?: string;

    /**
     * Name of the show
     */
    name?: string;

    /**
     * Whether to display titles for productions under this show. If false, dates are shown instead.
     */
    use_titles?: boolean;

    /**
     * URL-friendly name for the show
     */
    slug?: string;

    tune_ins?: ApiTuneIn[];

    logo1?: string;

    logo1_landscape?: string;

    logo_square?: string;

    /**
     * Brand color for the show
     */
    brand_color?: ApiBrandColor;

}

@Model('AbbreviatedShow')
export class ApiAbbreviatedShow extends BaseModel implements AbbreviatedShowRequest {

    
    
    id: string;

    /**
     * Name of the show
     */
    
    
    name: string;

    /**
     * Whether to display titles for productions under this show. If false, dates are shown instead.
     */
    
    
    use_titles: boolean;

    /**
     * URL-friendly name for the show
     */
    
    
    slug: string;

    @Type('ApiTuneIn')
    @Expand()
    tune_ins: ApiTuneIn[];

    
    
    logo1: string;

    
    
    logo1_landscape: string;

    
    
    logo_square: string;

    /**
     * Brand color for the show
     */
    @Type('ApiBrandColor')
    @Expand()
    brand_color: ApiBrandColor;

}
